import React, {PureComponent, CSSProperties} from 'react'
import cxs from 'cxs/component'
import Theme, {mediaQueries} from 'Theme'
import {ICrudStore} from 'Store'
import {store as mainStore} from '../App'
import History, {toParentPath} from 'helpers/History'
import {t, T} from 'helpers/i18n'
import {Validation} from 'helpers/Validation'
import {mapValues, objectValues} from 'helpers/Utils'
import {Button, Field, IField, FieldType} from 'elements'
import PassengerCategory from '../modules/PassengerCategories/Model'

interface Props<P> {
  fields: IField[]
  values?: any
  store?: ICrudStore<P>
  loading?: string | string[]
  delete?: boolean

  priceFields: IField[] | undefined

  onSubmit?(values: object): void

  onDelete?(): void

  onDisable?(disable: boolean): void

  onCancel?(): void

  onTramoHora?(value: boolean): void
}

interface State {
  values: object
  pricesValues: any
  showHora: boolean
}

class FormStretch<P> extends PureComponent<Props<P>, State> {
  fields: IField[]
  priceFields: IField[] = []
  schema: object
  stretchSchema: object = {}
  state: State = {
    values: {},
    pricesValues: {},
    showHora: false
  }

  mapNameId = {}

  constructor(props: Props<P>) {
    super(props)
    this.fields = props.fields.filter(field => field)
    console.log('FormStretch - constructor - this.fields: ', this.fields)
    this.schema = this.fields.reduce((previous, {name, rules, column}) => {
      previous[column? column: name] = rules
      return previous
    }, {})
    if (props.priceFields) { // hay passengerCategories en el sistema
      this.priceFields = props.priceFields.filter(field => field)
      this.stretchSchema = this.priceFields.reduce((previous, {name, rules}) => {
        previous[name] = rules
        return previous
      }, {})
      this.priceFields.forEach((priceField) => {
        this.mapNameId[priceField.name] = priceField.id
      })
    }

    const tramoHora = this.fields.filter(value => value.name === 'tramoHora')[0]
    // console.log('FormStretch - constructor - tramoHora: ', tramoHora)
    console.log('FormStretch - constructor - props.values: ', props.values)
    this.state.showHora = this.props.values !== undefined? this.props.values.tramoHora : tramoHora.defaultValue
    // console.log('FormStretch - constructor - state.showHora: ', this.state.showHora)
    // console.log('FormStretch - constructor - props.fields: ', this.props.fields)
  }

  componentWillMount(): void {
    this.setState({
        values: this.parsedValues(),
        pricesValues: this.parsedPricesValues(this.props)
      },
      () => {
        // console.log('state changed in componentWillMount')
      })
  }

  onChange = (event) => {
    console.log('event', event)
  }

  handleChange = (name: string, value: string | null | boolean, column: string) => {
    // console.log('handleChange: ', `name: ${name} value: ${value} column: ${column}`)
    this.setState({values: {...this.state.values, [column? column: name]: value}}, () => {
      console.log('handleChange: state.value', this.state.values)
    })
    console.log('name', name)
    console.log('value', value)
    console.log('column', column)
    if (name === 'tramoHora') {
      this.setState({showHora: value as boolean})
    }
  }

  handleChangePrices = (name: string, value: string | null) => {
    // console.log('handleChange: ', `name: ${name} value: ${value}`)
    this.setState({pricesValues: {...this.state.pricesValues, [name]: value}}, () => {
      // console.log('handleChangePrices: state.values', this.state.values)
    })

  }

  handleCancel = () => {
    // console.log('handleCancel')
    const {onCancel} = this.props
    if (onCancel) return onCancel()
    toParentPath()
  }

  handleDisable = (disable: boolean) => () => {
    // console.log('handleDisable')
    const {values, store, onDisable} = this.props
    const accept = confirm(t(disable ? 'confirmDisable' : 'confirmEnable'))
    if (accept) {
      if (onDisable) return onDisable(disable)
      if (store && store.disable && values) {
        store.disable(values.id, disable).then(toParentPath)
      }
    }
  }

  handleDelete = () => {
    /*console.log('handleDelete')
    const {values, store, onDelete} = this.props

    const accept = confirm(t('confirmDelete'))
    if (accept) {
      if (onDelete) return onDelete()
      if (store && store.delete && values) {
        store.delete(values.id).then(toParentPath)
      }
    }*/
  }

  handleReset = () => {
    console.log('handleReset')
    this.setState({values: this.parsedValues(), pricesValues: this.parsedPricesValues(this.props)})
  }

  changeToId = (stretchPrices) => {
    console.log('changeToId')
    let result = {}
    let {pricesValues} = this.state
    for (const item in stretchPrices) {
      if (stretchPrices.hasOwnProperty(item)) {
        // console.log('changeToId - item', item)
        result[this.mapNameId[item]]= pricesValues[item]
      }
    }
    // return stretchPrices
    return result
  }

  handleSubmit = () => {
    // console.log('handleSubmit - priceFields_', this.props.priceFields)
    const {fields, values: propsValues, store, onSubmit} = this.props
    let values = {...this.state.values}
    let pricesValues = this.state.pricesValues
    // console.log('handleSubmit - values', values)
    // console.log('handleSubmit - pricesValues', pricesValues)
    // console.log('handleSubmit - schema', this.schema)
    // console.log('handleSubmit - stretchSchema', this.stretchSchema)
    const validation = new Validation(values, this.schema)
    const stretchValidation = new Validation(pricesValues, this.stretchSchema)
    console.log('validation.valid', validation.valid)
    console.log('validation', validation)
    console.log('stretchValidation.valid', stretchValidation.valid)
    console.log('stretchValidation', stretchValidation)
    if (validation.valid && stretchValidation.valid) {
      // Remove unmodified value
      this.fields.map(field => {
        // console.log(' values[field.column? field.column: field.name]',  values[field.column? field.column: field.name])
        // console.log(' propsValues[field.column? field.column: field.name]',  propsValues[field.column? field.column: field.name])
        if (propsValues && values[field.column? field.column: field.name] === propsValues[field.column? field.column: field.name]) {
          delete values[field.column? field.column: field.name]
        }

      })

      /*console.log('propsValues', propsValues)*/
      const propsPriceValues = this.parsedPricesValues(propsValues)
      this.priceFields.map(field => {
        // console.log('pricesValues[field.name]', pricesValues[field.name])
        // console.log('propsValues[field.name]', propsPriceValues[field.name])
        if (propsPriceValues && pricesValues[field.name] === propsPriceValues[field.name]) {
          delete pricesValues[field.name]
        }

      })
      // console.log('pricesValues', pricesValues)

      if (Object.keys(values).length === 0 && Object.keys(pricesValues).length === 0)
        return mainStore.UI.newWarning(T('nothingModified'))

      // Convert empty strings to null
      values = mapValues(values, value => (value === '' ? null : value))
      pricesValues = mapValues(pricesValues, value => (value === '' ? null : value))

      // Use FormData instead of JSON if there is a image in value
      let data
      if (Object.keys(this.schema).includes('image')) {
        // console.log('handleSubmit - image')
        data = new FormData()
        Object.keys(values).forEach(key => {
          if (values[key]) data.append(key, values[key])
        })
      } else {
        data = {
          /*values: values,
          stretchValues: this.changeToId(pricesValues)*/
        }
        if (pricesValues) {
          data.stretchValues = this.changeToId(pricesValues)
        }
        data.values = values
      }
      // console.log('handleSubmit - data', data)
      // console.log('handleSubmit - propsValues', propsValues)
      if (onSubmit) return onSubmit(data)
      // console.log('!onSubmit')
      if (store && data) {
        let request
        if (propsValues) {
          request = store.update!(propsValues.id, data)
        } else {
          request = store.create(data)
        }
        request.then(toParentPath)
      } else {
        mainStore.UI.newWarning('error indefinido')
      }
    } else { // error en la validacion
      // console.log('FormStretch -handleSubmit - !validation.valid', validation)
      // console.log('handleSubmit - !stretchValidation.valid', stretchValidation)
      if (!validation.valid)
        mainStore.UI.newWarning(objectValues(validation.errors).join('\n'))
      if (!stretchValidation.valid)
        mainStore.UI.newWarning(objectValues(stretchValidation.errors).join('\n'))
    }
  }

  render() {
    console.log('FormStretch - render()')
    const {delete: canBeDeleted, loading} = this.props
    const {values, pricesValues, showHora} = this.state
    // console.log('FormStretch - render - this.props.values', this.props.values)
    // console.log('FormStretch - render - \'disabled\' in (this.props.values || {})', 'disabled' in (this.props.values || {}))
    const canBeDisabled = 'disabled' in (this.props.values || {})
    const hasParent = (History.location.pathname.match(/\//g) || []).length >= 2

    return (
      <Wrapper
      >
        {this.fields.map(field => {
          if ((field.name === 'hora' && showHora) || field.name !== 'hora') {
            return (
              <Field
                key={field.name}
                field={{
                  ...field,
                  value: values[field.column ? field.column : field.name] || (values[field.column ? field.column : field.name] === 0 ? '0' : '')
                }}
                onChange={this.handleChange}
              />
            )
          } else return null
          })}

        <div style={{
          display: 'block',
          marginLeft: '20px',
          marginTop: '10px'
        }}>
          <label style={{
            fontSize: 'large',
            paddingTop: '100px',
            marginLeft: '20px'
          }}>{T('pricesWithoutTax')}</label>

          {this.priceFields.length > 0 && <WrapperPrices>
            {this.priceFields.map(field => {
              // console.log('field', field)
              return (<Field
                key={field.name}
                field={{...field, value: pricesValues[field.name] || ''}}
                onChange={this.handleChangePrices}
              />)
            })}
          </WrapperPrices>}

          {this.priceFields.length === 0 && (
            <div>No hay categorías de pasajero, por favor añada categorías de pasajero</div>
          )}
        </div>

        <ButtonsBar>
          {hasParent && (
            <StyledButton onClick={this.handleCancel}>
              {t('cancel')}
            </StyledButton>
          )}
          {this.props.values && canBeDisabled ? (
            this.props.values.disabled ? (
              <StyledButton onClick={this.handleDisable(false)}>
                {t('enable')}
              </StyledButton>
            ) : (
              <StyledButton onClick={this.handleDisable(true)}>
                {t('disable')}
              </StyledButton>
            )
          ) : canBeDeleted ? (
            <StyledButton onClick={this.handleDelete}>
              {t('delete')}
            </StyledButton>
          ) : null}
          <StyledButton onClick={this.handleReset}>{t('reset')}</StyledButton>
          <StyledButton primary loading={loading} onClick={this.handleSubmit}>
            {t('save')}
          </StyledButton>
        </ButtonsBar>
      </Wrapper>
    )
  }

  private parsedValues(props: Props<P> = this.props) {
    const values = props.values || {}

    // console.log('FormStretch - parsedValues - values: ', values)
    const result = this.fields.reduce(
      (fields, field) => {
        // console.log('FormStretch - field', field)
        // console.log('FormStretch - values[field.column? field.column: field.name]', values[field.column? field.column: field.name])
        return {
          ...fields,
          [field.column? field.column: field.name]:
            values[field.column? field.column: field.name] === undefined? field.defaultValue : values[field.column? field.column: field.name] ||
              (field.type === FieldType.Select
                ? field.placeholder
                  ? null
                  : field.options && field.options[0] && field.options[0].value
                : field.type === FieldType.Date ? new Date() : values[field.column? field.column: field.name])
        }
      },
      {}
    )
    // console.log('parsedValues - result', result)
    return result
  }/*
  antes de añadir prices
  private parsedValues(props: Props<P> = this.props) {
    const values = props.values || {}

    console.log('parsedValues: ', values)
    const result = this.fields.reduce(
      (fields, field) => ({
        ...fields,
        [field.name]:
        values[field.name] ||
        (field.type === FieldType.Select
          ? field.placeholder
            ? null
            : field.options && field.options[0] && field.options[0].value
          : field.type === FieldType.Date ? new Date() : values[field.name])
      }),
      {}
    )
    console.log('parsedValues - result', result)
    return result
  }*/

  private parsedPricesValues(props: Props<P> = this.props) {

    const values = this.priceFields || []
    // console.log('parsedPricesValues - this.priceFields: ', values)
    const result = values.reduce(
      (fields, field: IField) => {
        // console.log('parsedPricesValues - field', field)
        return {
          ...fields,
          /*[Number(field.id)]: field.value*/
          [field.name]: field.value||
          (field.type === FieldType.Select
            ? field.placeholder
              ? null
              : field.options && field.options[0] && field.options[0].value
            : field.type === FieldType.Date ? new Date() : values[field.name])
        }
      },
      {}
    )
    // console.log('parsedPricesValues - result', result)
    return result
  }
}

export default FormStretch

const Wrapper = cxs('div')({
  paddingBottom: Theme.size.bar,
  [mediaQueries.desktop]: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingBottom: 0
  } as CSSProperties
} as CSSProperties)

const WrapperPrices = cxs('div')({
  paddingLeft: '20px',
  [mediaQueries.desktop]: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingBottom: 0
  } as CSSProperties
} as CSSProperties)

const ButtonsBar = cxs('div')({
  display: 'flex',
  width: '100%',
  position: 'absolute',
  bottom: 0,
  backgroundColor: Theme.color.background,
  zIndex: 1,
  borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  '> button': {
    flex: 'auto',
    borderRight: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    ':last-child': {
      borderWidth: 0
    }
  },
  [mediaQueries.desktop]: {
    position: 'initial',
    marginTop: Theme.size.space[2],
    borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`
  }
} as CSSProperties)

const StyledButton = cxs(Button)({
  flex: 2,
  [mediaQueries.desktop]: {
    padding: Theme.size.space[2]
  }
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FormStretch.tsx